export default {
  "nav.home": "Strona główna",
  "nav.categories": "Kategorie",
  "nav.articles": "Poradniki",
  "nav.contact": "Kontakt",
  "footer.copyright": "© 2026 KakobuyFinds.ink. Wszelkie prawa zastrzeżone.",
  "footer.description": "KakobuyFinds.ink to niezależny portal informacyjny poświęcony arkuszom zakupowym Kakobuy Spreadsheet. Znajdziesz tutaj aktualne listy produktów, poradniki oraz porównania najlepszych spreadsheetów zakupowych.",
  "footer.categories": "Kategorie",
  "footer.articles": "Artykuły SEO",
  "footer.guides": "Poradniki",
  "footer.privacy": "Polityka prywatności",
  "footer.terms": "Regulamin",
  "footer.disclaimer": "Zastrzeżenie",
  "cta.kakobuySheet": "kakobuy sheet",
  "cta.buyItNow": "buy it now",
  "cta.viewSpreadsheet": "Zobacz najnowszy Kakobuy Spreadsheet",
  "cta.browseGuides": "Przeglądaj poradniki",
  "cta.goToKakobuy": "PRZEJDŹ DO KAKOBUY SHEET",
  "category.all": "Wszystkie kategorie",
  "category.select": "Wybierz kategorię",
  "badge.updated": "Aktualizowane",
  "badge.verified": "Zweryfikowane",
  "badge.safe": "Bezpieczne",
  "badge.polish": "Polska baza",
  "newsletter.title": "Otrzymuj najnowsze aktualizacje Kakobuy Spreadsheet",
  "newsletter.subscribe": "Zapisz się",
  "newsletter.placeholder": "Twój adres email",
  "newsletter.success": "Dziękujemy za zapisanie się!",
  "newsletter.error": "Wystąpił błąd. Spróbuj ponownie.",
  "article.readMore": "Czytaj więcej",
  "article.backToHome": "← Powrót do strony głównej",
  "article.relatedCategories": "Powiązane kategorie",
};